import actions from './actions'
import invoice2sActions from '../invoice2s/actions'

export default function Invoice2LinesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.ADD_PENDING_INVOICE2LINE:
      // saveSuccess true closes the lines2 modal, same as a real save would.
      return {
        ...state,
        pendingList: [...(state.pendingList || []), action.line],
        editing: null,
        loading: false,
        saveSuccess: true,
      }
    case actions.REMOVE_PENDING_INVOICE2LINE:
      return {
        ...state,
        pendingList: (state.pendingList || []).filter((p, i) => i !== action.index),
      }
    case actions.CLEAR_PENDING_INVOICE2LINES:
      return {
        ...state,
        pendingList: [],
      }
    // Opening ANY invoice dialog (new or existing) or leaving it discards
    // not-yet-flushed lines, so they can never leak into a different invoice.
    case invoice2sActions.NEW_INVOICE2:
    case invoice2sActions.EDIT_INVOICE2:
    case invoice2sActions.RESET_INVOICE2:
      return {
        ...state,
        pendingList: [],
      }
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVOICE2LINE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVOICE2LINE:
      console.log('EDIT_INVOICE2LINE', action)
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVOICE2LINE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_INVOICE2LINE:
      return {
        ...state,
        editing: { Invoice2LineID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_INVOICE2LINE_RECIEVED ||
      actions.UPDATE_INVOICE2LINE_RECIEVED ||
      actions.DELETE_INVOICE2LINE_RECIEVED:
      return {
        ...state,
        editing: { Invoice2LineID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
